import React from 'react';
import Badge from 'react-bootstrap/Badge';

import { GetOrganizationalUnitDto } from '../../../common/snrwbCore/autogenerated/snrwbApiClient/models';

export default (props: { organizationalUnit: GetOrganizationalUnitDto }) => {
  return (
    <>
      {props.organizationalUnit?.shortname && (
        <Badge bg="warning" text="dark" className="me-1">
          {props.organizationalUnit.shortname}
        </Badge>
      )}
      {(props.organizationalUnit?.notified ||
        props.organizationalUnit?.nationalTechnicalAssessmentUnit ||
        !props.organizationalUnit?.shortname) && (
        <span>{props?.organizationalUnit?.name}</span>
      )}
    </>
  );
};
